(function () {
    'use strict';

    angular
        .module('app.tasks')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                  state: 'tasks',
                  config: {
                      abstract: true,
                      url: '/tasks',
                      template: '<ui-view/>',
                      settings: {
                          authMode: 1,
                          requireOps: true
                          
                      },
                      resolve: {
                          authenticationRequired: ['userService', function (userService) {
                              userService.isAuthenticatedThrowError();
                          }]
                      }
                  }
              },
            {
                state: 'tasks.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/tasks/list.html?v=' + opsIncludeVersion,
                    controller: 'TasksListController',
                    controllerAs: 'vm',
                    title: 'Tasks',
                    resolve: {
                        canAccess: ['userService', function (userService) {
                            if (userService.userType() == "0") {
                                throw { name: "NotAdmin" };
                            }
                        }]
                    }
                }
            },
             {
                 state: 'tasks.details',
                 config: {
                     url: '/detail/:id',
                     templateUrl: 'app/tasks/details.html?v=' + opsIncludeVersion,
                     controller: 'TaskDetailController',
                     controllerAs: 'vm',
                     title: 'Tasks',
                     params: { fromDisplay: true, fromDailySetup: false},
                     settings: {}
                 }
             },
            {
                state: 'tasks.display',
                config: {
                    url: '/display',
                    templateUrl: 'app/tasks/tasks.html?v=' + opsIncludeVersion,
                    controller: 'TasksController',
                    controllerAs: 'vm',
                    title: 'Tasks',
                    settings: {
                        nav: 400,
                        content: '<i class="fa fa-check-square-o"></i> <span class="leftNavText">Tasks</span>',
                        badgeContent: '{{vm.tasksCount}}',
                        authMode: 1,
                        requireOps: true,
                        mobileButton: true
                    }
                }
            },
            {
                state: 'tasks.templates',
                config: {
                    url: '/templates',
                    templateUrl: 'app/tasks/templatesList.html?v=' + opsIncludeVersion,
                    controller: 'TasksTemplatesController',
                    controllerAs: 'vm',
                    title: 'Task Templates',
                    resolve: {
                        canAccess: ['userService', function (userService) {
                            if (userService.userType() == "0") {
                                throw { name: "NotAdmin" };
                            }
                        }]
                    }
                }
            },
            {
                state: 'tasks.templatedetails',
                config: {
                    url: '/templatedetails/:uid',
                    templateUrl: 'app/tasks/templatedetails.html?v=' + opsIncludeVersion,
                    controller: 'TaskTemplateDetailController',
                    controllerAs: 'vm',
                    title: 'Task Template',
                    resolve: {
                        canAccess: ['userService', function (userService) {
                            if (userService.userType() == "0") {
                                throw { name: "NotAdmin" };
                            }
                        }]
                    }
                }
            }
        ];
    }
})();
